import PropTypes from 'prop-types';
import React from 'react';
import { buildImagePath } from '../../JobComponents/Company/Image/logo';

import './GroupBanner.scss';

export default class GroupBanner extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        src: PropTypes.string,
        alt: PropTypes.string,
    };

    static defaultProps = {
        src: '',
        alt: '',
    };

    render() {
        const injectedTransforms = {
            scaleWidth: 'f_auto,q_auto,c_scale,w_1200',
            fillWidth: 'f_auto,q_auto,c_fill,w_1200,h_250,g_auto',
            fixedAspectRatio: 'f_auto,q_auto,c_fill,g_auto,w_1150,ar_230:53',
        };
        const { src, alt } = this.props;
        return (
            <div className="component-Groups-GroupBanner">
                <img
                    className="banner-img"
                    src={buildImagePath(
                        src,
                        'fixedAspectRatio',
                        injectedTransforms
                    )}
                    alt={alt}
                />
            </div>
        );
    }
}
